<template>
  <LayoutPage title="My Account">
    <MyAccountProfile />
  </LayoutPage>
</template>

<script>
import LayoutPage from "@layout/LayoutPage.vue";
import MyAccountProfile from "./Profile.vue";

export default {
  name: "PageMyAccount",
  components: {
    LayoutPage,
    MyAccountProfile,
  },
};
</script>
